var _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.5,
    y: 2.5,
    width: 3,
    height: 3,
    rx: 1.5,
    fill: "#00A1B1"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8.5,
    y: 8.5,
    width: 3,
    height: 3,
    rx: 1.5,
    fill: "#00A1B1"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 8.5,
    y: 14.5,
    width: 3,
    height: 3,
    rx: 1.5,
    fill: "#00A1B1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMore);
export default __webpack_public_path__ + "static/media/more.d0a8f01b871c0d3c9d411b449a75ab47.svg";
export { ForwardRef as ReactComponent };